import React, { useEffect, useState } from 'react'
import './dashboard.css'
import {
  FaAlignLeft, FaUserAlt, FaTachometerAlt, FaPaperPlane,
  FaExchangeAlt, FaMoneyCheck, FaDollarSign, FaLandmark,
  FaPiggyBank, FaLifeRing, FaReceipt, FaTicketAlt, FaSignOutAlt
} from 'react-icons/fa'
import Sidebar from './Sidebar'
import { Link, useNavigate } from 'react-router-dom'
import axios from 'axios'
import { useAuthContext } from '../../Hooks/useAuthContext'
import Loader from '../../Component/Loader/Loader'

function Dashboard() {
  const [sidemenu, setSideMenu]               = useState(false)
  const [shouldMenuSlide, setShouldMenuSlide] = useState(false)
  const [data, setData]                       = useState(null)
  const [dashUser, setdashUser]               = useState(false)
  const navigate                              = useNavigate()
  const { user, dispatch }                    = useAuthContext()

  const [queryData, setQueryData] = useState({
    activeLoans: null,
    paymentReq:  null,
    AFD:         null,
    tickets:     null,
  })

  const [loanData, setLoanData] = useState([])

  const logout = () => {
    dispatch({ type: 'LOGOUT', payload: null })
    setTimeout(() => navigate('/login'), 3000)
  }

  /* ── Data fetching (all unchanged) ──────────────────── */
  useEffect(() => {
    axios.get(`${process.env.REACT_APP_BACKEND_URL}/user/loans`, {
      headers: { Authorization: `Bearer ${user.token}` }
    }).then(r => setQueryData(p => ({ ...p, activeLoans: r.data.length })))
      .catch(e => console.log(e))
  }, [user.token])

  useEffect(() => {
    axios.get(`${process.env.REACT_APP_BACKEND_URL}/user/get-fixed-deposits`, {
      headers: { Authorization: `Bearer ${user.token}` }
    }).then(r => setQueryData(p => ({ ...p, AFD: r.data.length })))
      .catch(e => console.log(e))
  }, [user.token])

  useEffect(() => {
    axios.get(`${process.env.REACT_APP_BACKEND_URL}/user/get-payment-request`, {
      headers: { Authorization: `Bearer ${user.token}` }
    }).then(r => setQueryData(p => ({ ...p, paymentReq: r.data.length })))
      .catch(e => console.log(e))
  }, [user.token])

  useEffect(() => {
    axios.get(`${process.env.REACT_APP_BACKEND_URL}/admin/isadmin`, {
      headers: { Authorization: `Bearer ${user.token}` }
    }).then(r => {
      if (r.data.admin)      navigate('/admin-panel')
      else if (r.data.user)  console.log('OK')
      else                   navigate('/')
    }).catch(e => console.log(e))
  }, [user.token])

  useEffect(() => {
    axios.get(`${process.env.REACT_APP_BACKEND_URL}/user/loans`, {
      headers: { Authorization: `Bearer ${user.token}` }
    }).then(r => setLoanData(r.data.filter(d => d.status === 'approved')))
      .catch(e => console.log(e))
  }, [user.token])

  useEffect(() => {
    axios.get(`${process.env.REACT_APP_BACKEND_URL}/user/get-tickets`, {
      headers: { Authorization: `Bearer ${user.token}` }
    }).then(r => setQueryData(p => ({ ...p, tickets: r.data.length })))
      .catch(e => console.log(e))
  }, [user.token])

  useEffect(() => {
    axios.get(`${process.env.REACT_APP_BACKEND_URL}/user/get-user`, {
      headers: { Authorization: `Bearer ${user.token}` }
    }).then(r => setData(r.data))
      .catch(e => console.log(e.response))
  }, [])

  /* ── Activity card config ────────────────────────────── */
  const activities = [
    {
      label: 'Active Loans',
      value: queryData.activeLoans,
      to: '/loans/my_loans',
      cls: 'activit1',
      icon: (
        <svg width="18" height="18" fill="none" stroke="currentColor" strokeWidth="1.8" viewBox="0 0 24 24">
          <rect x="3" y="3" width="18" height="18" rx="2"/>
          <line x1="3" y1="9" x2="21" y2="9"/>
          <line x1="9" y1="21" x2="9" y2="9"/>
        </svg>
      ),
    },
    {
      label: 'Payment Requests',
      value: queryData.paymentReq,
      to: '/payment_requests',
      cls: 'activit2',
      icon: (
        <svg width="18" height="18" fill="none" stroke="currentColor" strokeWidth="1.8" viewBox="0 0 24 24">
          <line x1="22" y1="2" x2="11" y2="13"/>
          <polygon points="22 2 15 22 11 13 2 9 22 2"/>
        </svg>
      ),
    },
    {
      label: 'Active Fixed Deposits',
      value: queryData.AFD,
      to: '/fixed_deposits/history',
      cls: 'activit3',
      icon: (
        <svg width="18" height="18" fill="none" stroke="currentColor" strokeWidth="1.8" viewBox="0 0 24 24">
          <line x1="12" y1="1" x2="12" y2="23"/>
          <path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"/>
        </svg>
      ),
    },
    {
      label: 'Active Tickets',
      value: queryData.tickets,
      to: '/tickets/create_ticket',
      cls: 'activit4',
      icon: (
        <svg width="18" height="18" fill="none" stroke="currentColor" strokeWidth="1.8" viewBox="0 0 24 24">
          <path d="M21.44 11.05l-9.19 9.19a6 6 0 0 1-8.49-8.49l9.19-9.19a4 4 0 0 1 5.66 5.66l-9.2 9.19a2 2 0 0 1-2.83-2.83l8.49-8.48"/>
        </svg>
      ),
    },
  ]

  /* ── Status badge helper ─────────────────────────────── */
  const statusBadge = (status) => {
    const map = {
      approved: 'success', pending: 'warning',
      rejected: 'danger',  active: 'info',
    }
    const cls = map[status?.toLowerCase()] || 'neutral'
    return <span className={`db-badge db-badge--${cls}`}>{status}</span>
  }

  return (
    <div className="dashboard">

      {/* ── Header ──────────────────────────────────────── */}
      <div className="dashboard-header">
        <div className="rights-side">
          <Link to="/" style={{ textDecoration: 'none' }}>
            <p>{process.env.REACT_APP_APP_NAME}</p>
          </Link>
          <FaAlignLeft size={18} onClick={() => {
            setShouldMenuSlide(true)
            setSideMenu(!sidemenu)
          }} />
        </div>

        <div className="left-side">
          <div className="dh-avatar" onClick={() => setdashUser(!dashUser)}>
            <FaUserAlt size={14} />
          </div>

          {dashUser && (
            <div className="user-menu">
              <Link to="/user-profile"><p>Profile Overview</p></Link>
              <Link to="/profile-setting"><p>Profile Settings</p></Link>
              <p className="logout" onClick={logout}>
                <FaSignOutAlt size={13} /> Logout
              </p>
            </div>
          )}
        </div>
      </div>

      {/* ── Body ───────────────────────────────────────── */}
      <div className="dashboard-main-section">
        {sidemenu && <Sidebar shouldMenuSlide={shouldMenuSlide} onClose={() => setSideMenu(false)} />}

        {data ? (
          <div className="dashboard-main">

            {/* Breadcrumb */}
            <div className="db-breadcrumb">
              Home &nbsp;/&nbsp; <span>Dashboard</span>
            </div>

            {/* ── Account number ─────────────────────────── */}
            <div className="db-card">
              <div className="db-card__bar" />
              <div className="db-card__body">
                <div className="card-body" style={{ margin: 0, border: 'none', boxShadow: 'none', padding: 0 }}>
                  <p>Account Number</p>
                  <span>{data.accountNumber}</span>
                </div>
              </div>
            </div>

            {/* ── Balances ───────────────────────────────── */}
            <div className="balances">
              {[
                { label: 'USD Balance', value: `$${data.balance.USD.toFixed(2)}` },
                { label: 'EUR Balance', value: `€${data.balance.EUR.toFixed(2)}` },
                { label: 'GBP Balance', value: `£${data.balance.GBP.toFixed(2)}` },
              ].map((b) => (
                <div className="card-body" key={b.label}>
                  <p>{b.label}</p>
                  <span>{b.value}</span>
                </div>
              ))}
            </div>

            {/* ── Minimum withdrawal ─────────────────────── */}
            {data?.minimumWithdrawal && (
              <div className="card-body">
                <p>Minimum Withdrawal Amount</p>
                <span>
                  {data.minimumWithdrawal?.amount} {data.minimumWithdrawal?.currency}
                </span>
              </div>
            )}

            {/* ── Activity stats ─────────────────────────── */}
            <div className="activities">
              {activities.map((a) => (
                <div className={`card-body ${a.cls}`} key={a.label}>
                  <p>{a.label}</p>
                  <span className="activity-data">{a.value ?? '—'}</span>
                  <Link style={{ textDecoration: 'none', color: 'white' }} to={a.to}>
                    <h3>View →</h3>
                  </Link>
                </div>
              ))}
            </div>

            {/* ── Upcoming loans table ───────────────────── */}
            <div className="db-card">
              <div className="db-card__bar" />
              <div className="db-card__body">
                <div className="db-card__head">
                  <h3 className="db-card__title">Upcoming Loan Payments</h3>
                </div>

                <div className="loan-table">
                  <table className="equal-table">
                    <thead>
                      <tr>
                        <th>#</th>
                        <th>Loan Product</th>
                        <th>Total Payable</th>
                        <th>Amount Paid</th>
                        <th>Due Amount</th>
                        <th>Status</th>
                        <th>Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      {loanData.length > 0 ? (
                        loanData.map((loan, i) => (
                          <tr key={i}>
                            <td>{i + 1}</td>
                            <td>{loan.loanProduct}</td>
                            <td>{loan.totalpayableAmount} {loan.currency}</td>
                            <td>{loan.amountPaid} {loan.currency}</td>
                            <td>{loan.dueAmount} {loan.currency}</td>
                            <td>{statusBadge(loan.status)}</td>
                            <td className="pay-button">
                              <Link to="/deposit/manual_methods">
                                <button>Pay Now</button>
                              </Link>
                            </td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan="7" className="no-loan-message">
                            No active loan payments due
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>

              </div>
            </div>

          </div>
        ) : (
          <Loader />
        )}
      </div>

    </div>
  )
}

export default Dashboard